function register() {
    if( !$('.customers-register').length ) {
        return false;
    }

    const form = $('#create_customer');
    const submit = form.find('button');

    // Password Confirmation
    submit.on('click', function() {
        const errors = $('#create_customer .errors');

        // Remove password confirmation error if present.
        errors.remove();

        // Check value of password fields match
        if( $('#register-password').val() != $('#register-password-confirmation').val() ) {
            form.prepend('<div class="errors"><ul><li>Passwords do not match. Please try again.</li></ul></div>');

            // Scroll to top
            $('html, body').animate({
                scrollTop: form.offset().top - 200
            }, 500);
        } else {
            form.submit();
        }
    });

    // Reset errors on input change
    form.on('input', 'input', function() {
        $('#create_customer .errors').remove();
    });
}

function login() {
    if( !$('.account-login').length ) {
        return false;
    }

    const url = window.location.href;

    // Switch current navigation to orders
    if( url.indexOf('#recover') !== -1 ) {
        $('.account-login').remove();
        $('.account-forgot').show();
    }
}

function navigation() {
    if( !$('.account-navigation').length ) {
        return false;
    }

    const url = window.location.href;

    // Switch current navigation to orders
    if( url.indexOf('orders=true') !== -1 ) {
        $('.account-navigation a').removeClass('is-current');
        $('#account-navigation-orders').addClass('is-current');
        $('h1').text('Order History.');
        $('.account-overview').remove();
        $('.account-order-history').show();
    }

    if( !isDesktop() ) {
        const navigation = $('.account-navigation .wrapper');

        navigation.find('.is-current').prependTo(navigation);

        navigation.on('click', function() {
            if( navigation.hasClass('is-open') ) {
                navigation.removeClass('is-open');
            } else {
                navigation.addClass('is-open');
            }
        });
    }
}

function joinNames() {
    // Split full name into First and Last fields
    $('.full-name-field').on('input', function() {
        const fullName = $(this).val().split(' ');
        const firstName = fullName[0];
        const lastName = fullName.length > 1 ? fullName[fullName.length - 1] : '';
        const thisForm = $(this).closest('form');

        thisForm.find('.first-name-field').val(firstName);
        thisForm.find('.last-name-field').val(lastName);
    });
}

function customerAddAddress() {
    const addAddress = $('.add-address');

    if( !addAddress.length ) {
        return false;
    }

    addAddress.on('click', function() {
        $(this).siblings('.account-addresses__add-address').show();
        addAddress.remove();
    });
}

$(document).ready(function() {
    register();
    login();
    navigation();
    joinNames();
    customerAddAddress();
});
